import { FC } from "react";

import { getRideRouteType, IRideDto } from "@ryde/shared";

import { FramerTooltip } from "../../../../common";
import { CourseIndicatorIcon } from "./course.indicator.icon";
import { CourseIndicatorTooltip } from "./course.indicator.tooltip";

interface ICourseIndicatorRides {
  rideDto: Partial<IRideDto>;
}

export const CourseIndicatorRides: FC<ICourseIndicatorRides> = ({
  rideDto,
}) => {
  return (
    !!rideDto.courseId && (
      <FramerTooltip content={<CourseIndicatorTooltip rideDto={rideDto} />}>
        <CourseIndicatorIcon routeType={getRideRouteType(rideDto)} />
      </FramerTooltip>
    )
  );
};
